export default "__VITE_ASSET__DJnI11Xy__"